import { useAtom, useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import atoms from "../utils/atoms";
import fetchCourses from "../utils/fetchCourses";

export default function useSearchQuery() {
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(true);
	const [message, setMessage] = useState(false);

	const { search, sort, filters } = useAtomValue(atoms.form)

	useEffect(() => {
		setLoading(true);
		fetchCourses(search, filters, sort)
			.then((res) => {
				if (res && res.length) {
					setResults(res);
					setMessage(false);
					// console.log('res', res)
				} else if (res && !res.length && search.length > 1) {
					setResults(res);
					setMessage(true);
				} else {
					setMessage(false);
				}
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, [search, filters, sort]);

	return [results, loading, message];
}
